import { useSelector } from 'react-redux';

import { useGetSuggestions } from '@frontend/api';

import { useExtractedTables } from 'modules/extractedTables/ExtractedTableContext';

import { getActiveRootFile } from '../data/reducer';

export const useInferenceInfo = () => {
  const activeFile = useSelector(getActiveRootFile);
  const { extractedTables } = useExtractedTables();

  const suggestionsList = useGetSuggestions({
    queryOptions: {
      enabled: !!activeFile,
    },
    query: {
      sourcePartFileId: activeFile?.uuid,
    },
  });

  return { suggestionsList, extractedTables };
};
